<div class="user-menu-config-page">

  <div class="page-head">

    <div>

      <div class="eyebrow">
        USER MENU CONFIG
      </div>

      <h2>
        User Menu Config
      </h2>

      <p>
        Select module, onboarded entity and user to manage assigned menu availability.
      </p>

    </div>


    <button
      type="button"
      class="btn-light-custom"
      (click)="refresh()"
      [disabled]="
        loadingEntities ||
        loadingAffiliations ||
        loadingUsers ||
        loadingMenus
      "
    >
      <i class="bi bi-arrow-clockwise"></i>
      Refresh
    </button>

  </div>


  <div class="filter-card">

    <!-- <div class="section-heading">

      <div class="section-icon">
        <i class="bi bi-person-gear"></i>
      </div>

      <div>

        <h5>
          User Menu Mapping
        </h5>

        <p>
          Module → onboarded module → affiliation → user → assigned menus.
        </p>

      </div>

    </div> -->


    <div class="filter-grid">

      <div class="filter-step">

        <span class="step-no">
          1
        </span>

        <label>
          Module *
        </label>

        <select
          class="form-select"
          [(ngModel)]="selectedModuleName"
          (ngModelChange)="onModuleChange()"
        >

          <option value="">
            Select Module
          </option>

          <option
            *ngFor="
              let module of moduleOptions
            "
            [ngValue]="module"
          >
            {{ module }}
          </option>

        </select>

      </div>


      <div class="filter-step">

        <span class="step-no">
          2
        </span>

        <label>
          {{ moduleEntityLabel }}

          <span
            *ngIf="!requiresModuleEntity"
            class="optional"
          >
            Optional
          </span>

        </label>

        <select
          class="form-select"
          [(ngModel)]="selectedModuleId"
          (ngModelChange)="onModuleEntityChange()"
          [disabled]="
            !selectedModuleName ||
            !requiresModuleEntity ||
            loadingEntities
          "
        >

          <option [ngValue]="0">
            {{ moduleEntityPlaceholder }}
          </option>

          <option
            *ngFor="
              let entity of moduleEntities
            "
            [ngValue]="entity.id"
          >
            {{ entity.name }}
          </option>

        </select>

      </div>


      <div class="filter-step">

        <span class="step-no">
          3
        </span>

        <label>
          User Affiliation *
        </label>

        <select
          class="form-select"
          [(ngModel)]="selectedAffiliationType"
          (ngModelChange)="onAffiliationChange()"
          [disabled]="
            !selectedModuleName ||
            (
              requiresModuleEntity &&
              selectedModuleId <= 0
            ) ||
            loadingAffiliations ||
            affiliationTypes.length === 0
          "
        >

          <option value="">

            {{
              loadingAffiliations
                ? "Loading affiliations..."
                : "Select User Affiliation"
            }}

          </option>

          <option
            *ngFor="
              let affiliation of affiliationTypes
            "
            [value]="affiliation"
          >
            {{ affiliation }}
          </option>

        </select>

      </div>


      <div class="filter-step">

        <span class="step-no">
          4
        </span>

        <label>
          User *
        </label>

        <select
          class="form-select"
          [(ngModel)]="selectedUserId"
          (ngModelChange)="onUserChange()"
          [disabled]="
            !selectedModuleName ||
            !selectedAffiliationType ||
            (
              requiresModuleEntity &&
              selectedModuleId <= 0
            ) ||
            loadingUsers
          "
        >

          <option [ngValue]="0">

            {{
              loadingUsers
                ? "Loading users..."
                : "Select User"
            }}

          </option>

          <option
            *ngFor="
              let user of filteredUsers
            "
            [ngValue]="user.userId"
          >

            {{ user.displayName }}

            <ng-container
              *ngIf="user.affiliationType"
            >
              - {{ user.affiliationType }}
            </ng-container>

          </option>

        </select>

      </div>

    </div>


    <div
      class="selected-user-strip"
      *ngIf="selectedUser"
    >

      <div class="user-avatar">

        {{
          selectedUser?.displayName
            ?.charAt(0)
            ?.toUpperCase()
        }}

      </div>


      <div class="user-meta">

        <strong>
          {{ selectedUser?.displayName }}
        </strong>

        <span>

          User ID:
          {{ selectedUser?.userId }}

          <ng-container
            *ngIf="selectedUser?.affiliationType"
          >
            •
            {{ selectedUser?.affiliationType }}
          </ng-container>

          <ng-container
            *ngIf="selectedUser?.mobileNo"
          >
            •
            {{ selectedUser?.mobileNo }}
          </ng-container>

        </span>

      </div>

    </div>

  </div>


  <div
    class="empty-card"
    *ngIf="
      !selectedUserId &&
      !loadingUsers
    "
  >

    <div class="empty-icon">
      <i class="bi bi-person-check"></i>
    </div>

    <h5>
      Select a User
    </h5>

    <p>
      Select module, onboarded module, user affiliation and user to view assigned menus.
    </p>

  </div>


  <div
    class="data-card"
    *ngIf="
      selectedUserId > 0
    "
  >

    <div class="table-toolbar">

      <div>

        <h5>
          Assigned Menus
        </h5>

        <small>
          {{ filteredAssignedMenus.length }}
          menu(s) for
          {{ selectedUser?.displayName }}
        </small>

      </div>


      <div class="search-box">

        <i class="bi bi-search"></i>

        <input
          type="text"
          [(ngModel)]="searchText"
          placeholder="Search assigned menus..."
        />

      </div>

    </div>


    <div
      class="loading-box"
      *ngIf="loadingMenus"
    >

      <span
        class="spinner-border spinner-border-sm"
      ></span>

      Loading assigned menus...

    </div>


    <div
      class="table-responsive"
      *ngIf="!loadingMenus"
    >

      <table class="config-table">

        <thead>

          <tr>
            <th>Menu</th>
            <th>Code</th>
            <th>Type</th>
            <th>Route</th>
            <th>Module</th>
            <th>Default</th>
            <th class="text-end">
              Availability
            </th>
          </tr>

        </thead>


        <tbody>

          <tr
            *ngFor="
              let menu of filteredAssignedMenus
            "
          >

            <td>

              <div class="menu-name-cell">

                <div class="menu-icon">

                  <i
                    [class]="
                      menu.menuIconUrl ||
                      'bi bi-grid'
                    "
                  ></i>

                </div>


                <div>

                  <strong>
                    {{ menu.menuName }}
                  </strong>

                  <small>
                    Menu ID:
                    {{ menu.menuId }}
                  </small>

                </div>

              </div>

            </td>


            <td>
              <code>
                {{ menu.menuCode || "-" }}
              </code>
            </td>


            <td>

              <span
                class="type-badge parent"
                *ngIf="
                  menu.parentMenuId === 0
                "
              >
                Parent
              </span>

              <span
                class="type-badge child"
                *ngIf="
                  menu.parentMenuId > 0
                "
              >
                Sub Menu
              </span>

            </td>


            <td>
              <span class="route-text">
                {{ menu.templatePath || "-" }}
              </span>
            </td>


            <td>

              <span class="module-badge">
                {{
                  menu.moduleName ||
                  selectedModuleName ||
                  "-"
                }}
              </span>

            </td>


            <td>

              <span
                class="default-badge"
                *ngIf="
                  menu.isDefault === 1
                "
              >
                Yes
              </span>

              <span
                class="muted"
                *ngIf="
                  menu.isDefault !== 1
                "
              >
                -
              </span>

            </td>


            <td class="text-end">

              <div class="toggle-wrap">

                <!--
                  MINIMUM FIX:

                  SHOWN:
                  IsActive  = 1
                  IsDeleted = 0

                  HIDDEN:
                  IsActive  = 0
                  IsDeleted = 1

                  After refresh/login the API can return the
                  hidden record and this UI will continue
                  showing Hidden with the switch OFF.
                -->

                <span
                  class="toggle-status"
                  [class.active]="
                    menu.isActive === 1 &&
                    menu.isDeleted === 0
                  "
                >
                  {{
                    menu.isActive === 1 &&
                    menu.isDeleted === 0
                      ? "Shown"
                      : "Hidden"
                  }}
                </span>


                <label
                  class="switch"
                  [class.loading]="
                    isUpdating(
                      menu.subRoleId
                    )
                  "
                >

                  <input
                    type="checkbox"
                    [checked]="
                      menu.isActive === 1 &&
                      menu.isDeleted === 0
                    "
                    [disabled]="
                      isUpdating(
                        menu.subRoleId
                      )
                    "
                    (change)="
                      toggleMenu(
                        menu,
                        $event
                      )
                    "
                  />

                  <span class="slider"></span>

                </label>

              </div>

            </td>

          </tr>


          <tr
            *ngIf="
              filteredAssignedMenus.length === 0
            "
          >

            <td
              colspan="7"
              class="empty-cell"
            >
              No assigned menus found for this user.
            </td>

          </tr>

        </tbody>

      </table>

    </div>

  </div>

</div>